





















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import IconService from "../services/IconService";
import IconModel from "../models/IconModel";

@Component({})
export default class ImageSelector extends Vue {
    @Prop()
    value = null;
    @Prop({ default: false })
    disabled = false;

    dialog = false;
    itemSelected = null;
    iconList = [];
    imageData: any = {};
    imageb64: any = null;

    mounted() {
        var iList = this.$store.getters.getIconList;
        var self = this;
        if (!iList) {
            this.$store.dispatch("loadIconList").then(() => {
                self.$data.iconList = self.$store.getters.getIconList;
            });
        } else {
            this.$data.iconList = iList;
        }
    }

    @Watch("imageData.image")
    async watchImage(newVal: any) {
        if (newVal) {
            this.imageb64 = await this.toBase64(newVal);
        } else {
            this.imageb64 = null;
        }
    }

    @Watch("value")
    watchValue(newValue: any) {
        this.$data.itemSelected = newValue;
    }

    @Watch("itemSelected")
    watchItemSelected(newValue: any) {
        this.$emit('input', newValue);
    }

    handleClick() {
        (this.$refs.refSelect as any).blur();
        this.imageData = {};
        this.dialog = true;
    }

    handleNo() {
        this.dialog = false;
    }

    async handleYes() {
        let model = new IconModel();
        model.fldTNombre = this.imageData.fldTNombre;
        model.fldTRuta = this.imageb64;
        var res = await new IconService().insert(model);
        var self = this;
        this.$store.dispatch("loadIconList").then(function () {
            self.$data.iconList = self.$store.getters.getIconList;
            self.itemSelected = res.data.idNIcono;
            self.$emit("input", res.data.idNIcono);
            self.dialog = false;
        });
    }

    async toBase64(file: File) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    nameRules = [
        (v: any) => !!v || "Debe ingresar un nombre",
        (v: any) =>
            (v && v.length <= 250) ||
            "El nombre tiene que contener menos de 250 caracteres"
    ];

    private resolve = null;
    private reject = null;
}
